import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV2 } from '@retailer-platform/dashboard/routing'
import { marketingToolingAdminRouter } from './routing/marketingToolingAdminRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { marketingToolingAdminAccessControl } from './access-control/marketingToolingAdminAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'marketing-tooling',
  routes,
  totem: {
    tool: 'marketing-tooling-dashboard-tool', // TODO: Register ownership in Totem
  },
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    //scoped: [marketingToolingRouter],
    admin: [marketingToolingAdminRouter],
  },
  navigationEntries: [],
  adminNavigationEntries: [
    {
      attachToV2: AdminNavEntryPointV2.Marketing,
      subNavItems: [
        {
          route: 'app-admin-marketing-tooling-campaigns',
          labelId: 'admin.marketing.tooling.navigation.label',
          accessControl: marketingToolingAdminAccessControl,
          positionNavV2: 4,
        },
      ],
    },
  ],
  // NOTE TO DEV: run `yarn ipp domain register <your-system-name>` to register your domain with Totem here
}

export default definition
